import React from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BarChartIcon from '@mui/icons-material/BarChart';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import { Option } from '../../interfaces';

export const membersMenuOptions: Option[] = [
  {
    key: 'overview',
    link: '/manage/members/overview',
    icon: <VisibilityIcon />,
    inProduction: true,
  },
  {
    key: 'stats',
    link: '/manage/members/stats',
    icon: <BarChartIcon />,
  },
  {
    key: 'activityLog',
    link: '/manage/members/activity-log',
    icon: <HistoryIcon />,
  },
  {
    key: 'settings',
    link: '/manage/members/settings',
    icon: <SettingsIcon />,
  },
];
